<!-- @mouseleave="isMouseOver=false" @mouseenter="isMouseOver=true"-->
<template>
    <!-- CollectionOfUser -->
    <div class="page">
    <div class="collection px-2xl pt-xl container">

        <!-- PRODUCTS GRID {{colData.collection.col_name}}-->
        <h3>{{localize('Shared products')}}</h3>
        <div class="products">
            <preloader key="preloader" v-if="loadingData" class="products_loader" />

            <template v-if="!loadingData">
                <div v-for="item in colData.items" class="item" :key="item.product.PRO_ID">                    
                    <router-link class="item"                    
                        target="_blank"
                        :title="item.product.CatalogNo"                    
                        :to="`/product/${item.product.CatalogNo}`">  
                        <!-- todo add to .item-preview: margin-bottom: 5em; -->
                        <catalog-thumb :item="item.product" :size="big"></catalog-thumb>
                    </router-link>
                </div>
            </template>
        </div>

    </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import CatalogThumb from "@/components/catalog/CatalogThumb.vue";
export default {
  data() {
    return {
        loadingData:false,
        colData:null,
        col:-1
    };
  },
  components: {CatalogThumb},
  methods: {
      ...mapActions(["setItemToCollect","setCollectionsList"]),
        readCollectionItems(CollectionID,AUID)
        {        
            var vm=this;
            vm.loadingData=true;    
            var apiURL = "https://api.mis-implants.com/api/collections?AUID="+AUID+"&CollectionID="+CollectionID+"&ln="+vm.locale.ln;
            fetch(apiURL,{method: 'GET',mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
            .then(function(response){return response.json();})
            .then(function(response)
            {
                vm.colData = response;
                vm.loadingData=false;
            });         
        },      
  },
  mounted()
  {
    var vm=this;            
    var ColID = this.$route.query.id;
    var ColAuid = this.$route.query.auid;
    vm.readCollectionItems(ColID,ColAuid);
  },
  watch:
  {
  },
  computed: 
  {
    ...mapState(["collections", "auid","locale"]),
  }
};
</script>

<style scoped>
    .page
    {
        margin-top: 55px;
    }
    .collection
    {
        clear: both;
        width: 100%;
        min-height: 100vh;
    }
    .products
    {
        padding-top: 30px;
        width:100%;
        position: relative;
        display: grid;
        width: 100%;
        margin: initial;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 20px;
        row-gap: 6em;
        padding-bottom: 30px;        
    }
    .products .item {
        box-sizing: border-box;
    }
    .products .item span {
        color: white;
        margin: 30px;
        font-size: 30px;
    }
    @media only screen and (max-width: 800px) {
        .collection{
            clear: both;
        }     
        .products{
            height: calc(80vh - 170px);
            overflow-y: scroll;        
        }           
    }

</style>
